/* global WEBSOCKET_URL */
import { FC } from 'react';
// import { FC, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// import { Outlet, useNavigate } from 'react-router-dom';
import { CommunicationsModal } from '@components/CommunicationsCenter/CommunicationsModal/CommunicationsModal';
import { NotificationCenter } from '@components/interface/Notification';
import { StatusBottomBar } from '@components/interface/StatusBottomBar';
import { StatusBottomBarMobile } from '@components/interface/StatusBottomBarMobile';
import { NotificationProvider } from '@context/NotificationsContext';
import { PushNotificationProvider } from '@context/PushNotificationContext';
import { WebSocketProvider } from '@context/WebSocketContext';
import { useGetCommerce } from '@pages/Commerce/hooks/commerce';
// import { SubscriptionStatusBar } from '@pages/Subscriptionsv2/components/SubscriptionStatusBar';
import { useInitSubscriptionDetails, useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import { ModuleName } from '@utils/constants';
import { useChangeDeliveryStatus } from '@utils/hooks/useChangeDeliveryStatus';
import { useChangeOrderStatus } from '@utils/hooks/useChangeOrderStatus';
import { useChangePaymentStatus } from '@utils/hooks/useChangePaymentStatus';
import { useDesktop } from '@utils/hooks/useDesktop';
import { useIncomingOrder } from '@utils/hooks/useIncomingOrder';
import { useInitElectronPrinters } from '@utils/hooks/useInitElectronPrinters';
import { useInitElectronVersion } from '@utils/hooks/useInitElectronVersion';
import useModules from '@utils/hooks/useModules';
import { useRiderAssigned } from '@utils/hooks/useRiderAssigned';
import { useSimulateClick } from '@utils/hooks/useSimulateClick';
import NavBar from './NavBar/NavBar';
import Header from './header/Header';
import HeaderV3 from './header/HeaderV3';
// import { Button, Modal } from '@plick/ui';
// import { IconMap2 } from '@tabler/icons-react';
// import { usePostHog } from 'posthog-js/react';
import { CommunicationsBar } from '@components/CommunicationsCenter/CommunicationsBar/CommunicationsBar';
import { NotificationPermissionRequest } from '@components/NotificationPermissionRequest';
import { PwaInstallPrompt } from '@components/PwaInstallPrompt';
import { useActiveUserSocket } from '@hooks/useActiveUserSocket';

const PrivateGlobalHooks = () => {
  useInitSubscriptionDetails();
  useIncomingOrder();
  useRiderAssigned();
  useChangeOrderStatus();
  useChangePaymentStatus();
  useSimulateClick();
  useInitElectronPrinters();
  useInitElectronVersion();
  useChangeDeliveryStatus();
  return null;
};

const Layout: FC = () => {
  const isDesktop = useDesktop();
  useActiveUserSocket();
  const { commerce } = useGetCommerce();
  const { hasModule } = useModules();
  const { accountId } = useSubscription();
  // const { isFreemium, isTrial, accountId } = useSubscription();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const navigate = useNavigate();
  // const posthog = usePostHog();

  // ========================================
  // MODAL BLOQUEANTE DE DIRECCIÓN - DESACTIVADO
  // ========================================
  // Este modal se desactivó porque ahora tenemos la página de /configuracion-inicial
  // que maneja la configuración de dirección de forma más amigable y no bloqueante
  // useEffect(() => {
  //   if (!commerce.id) return;

  //   if (!commerce?.address?.latitude || !commerce?.address?.longitude) {
  //     setIsModalOpen(true);
  //   }
  // }, [commerce]);

  return (
    <WebSocketProvider
      url={WEBSOCKET_URL}
      accountId={accountId}
      commerceId={commerce?.id}
      allowConnection={hasModule(ModuleName.HISTORIAL) || false}
    >
      <NotificationProvider>
        <PushNotificationProvider>
          <PrivateGlobalHooks />
          <main className="w-screen h-screen flex flex-col">
            {isDesktop ? <Header /> : <HeaderV3 />}
            <div className="flex flex-1 flex-col-reverse lg:flex-row overflow-hidden pt-16 lg:pt-14 pb-[62.14px] lg:pb-0">
              <NavBar />

              {/* (isFreemium || isTrial) && !isDesktop && <SubscriptionStatusBar isMobile /> */}
              {/* StatusBottomBar Mobile: versión colapsable top */}
              {!isDesktop && <StatusBottomBarMobile />}
              <Outlet />
            </div>
            {/* StatusBottomBar Desktop: versión tradicional bottom */}
            {isDesktop && <StatusBottomBar />}
            {/* (isFreemium || isTrial) && isDesktop && <SubscriptionStatusBar /> */}
            {/* ========================================
              MODAL BLOQUEANTE DE DIRECCIÓN - DESACTIVADO
              ========================================
              Este modal se desactivó porque ahora tenemos la página de /configuracion-inicial
              que maneja la configuración de dirección de forma más amigable y no bloqueante
          */}
            {/* <Modal isOpen={isModalOpen}>
            <div className="flex flex-col items-center justify-center gap-4 p-4">
              <div className="flex items-center justify-center">
                <div
                  className="rounded-full p-3 border-[0.375rem] flex items-center justify-center"
                  style={{ borderColor: '#253746' }}
                >
                  <div className="w-[3.75rem] h-[3.75rem] flex items-center justify-center">
                    <IconMap2 className="w-full h-full" />
                  </div>
                </div>
              </div>
              <h1 className="text-xl text-center px-6 font-bold">
                Aparece en el catálogo de comercios de tu ciudad, sin costo.
              </h1>
              <h2 className="px-0 text-center mb-8">
                No dejes pasar la oportunidad de ser más visible y aumentar tus ventas.
              </h2>
              <h4 className="text-center">Solo te tomará 1 minuto. Da clic aquí 👇 y date de alta</h4>
              <Button.Primary
                text="Actualizar mi dirección"
                onClick={() => {
                  posthog.capture('update_commerce_location_click');
                  setIsModalOpen(false);
                  navigate('/datos-del-comercio/ubicacion');
                }}
              />
            </div>
          </Modal> */}
          </main>
          <NotificationCenter />
          <CommunicationsModal />
          <NotificationPermissionRequest />
          <PwaInstallPrompt />
        </PushNotificationProvider>
        <CommunicationsBar />
      </NotificationProvider>
    </WebSocketProvider>
  );
};

export default Layout;
